//index.vue
<template>
	<transition name="animation">
		<div :style="{ background: background }" v-if="visable" class="loaidng">
			<div class="loading-cell flash loading-logo-wrap" :class="{ 'loading-logo-wrap--mobile': useMobileLogo }">
				<img :src="imgSrc" alt="" class="loading-logo-img" :class="{ 'loading-logo-img--mobile': useMobileLogo }">
			</div>
		</div>
	</transition>
</template>

<script>
	import helper from '@/common/helper.js';
	export default {
		data() {
			return {
				visable: false,
				text: "loading...",
				background: "#0d131c",
				imgSrc:'',
				useMobileLogo: false
			};
		},
		mounted() {
			this.refreshLogo();
			this._onResize = () => this.refreshLogo();
			window.addEventListener('resize', this._onResize);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this._onResize);
		},
		methods: {
			refreshLogo() {
				const rule = helper.get('rule') || {};
				const mobile = typeof window !== 'undefined' && window.innerWidth < 1099;
				if (mobile && rule.website_mobile_logo) {
					this.useMobileLogo = true;
					this.imgSrc = rule.website_mobile_logo;
				} else {
					this.useMobileLogo = false;
					this.imgSrc = rule.website_pc_logo || process.env.VUE_APP_SITE_LOGO;
				}
			}
		}
	};
</script>

<style>
	.animation-enter,
	.animation-leave-to {
		opacity: 0;
	}

	.animation-enter-active,
	.animation-leave-active {
		transition: opacity 0s;
	}

	.loaidng {
		position: fixed;
		inset: 0;
		z-index: 9999;
		background: rgba(0, 0, 0, 0.3);
		display: flex;
		justify-content: center;
		align-items: center;
		color: #fff;
		font-size: 20px;
	}

	@-webkit-keyframes flash {

		0%,
		50%,
		to {
			opacity: 1
		}

		25%,
		75% {
			opacity: 0
		}
	}

	@keyframes flash {

		0%,
		50%,
		to {
			opacity: 1
		}

		25%,
		75% {
			opacity: 0
		}
	}

	.flash {
		-webkit-animation-name: flash;
		animation-name: flash;
		-webkit-animation-iteration-count: infinite;
		animation-iteration-count: infinite;
		-webkit-animation-duration: 4s;
		animation-duration: 4s
	}

	.loading-logo-wrap {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 16px 22px;
		box-sizing: border-box;
	}

	.loading-logo-wrap--mobile {
		padding-bottom: 28px;
	}

	.loading-logo-img {
		display: block;
		width: auto;
		height: auto;
		max-width: min(284px, 85vw);
		max-height: 70px;
		object-fit: contain;
	}

	.loading-logo-img--mobile {
		max-width: min(100px, 85vw);
		max-height: 92px;
		object-fit: contain;
	}
</style>
